import React, {
  useContext,
  createContext,
  Dispatch,
} from 'react';
import { RGBColor } from 'react-color';

interface HeaderData {
  title: string;
  eventName: string;
  leftBg: RGBColor;
  rightBg: RGBColor;
  hasLogout: boolean;
  isScout: boolean;
}

interface HeaderContextData {
  header: HeaderData;
  dispatchHeader: Dispatch<HeaderData>;
}
const init: HeaderData = {
  title: '',
  eventName: '',
  leftBg: {} as RGBColor,
  rightBg: {} as RGBColor,
  hasLogout: false,
  isScout: false,
};
const HeaderContext = createContext<HeaderContextData>({} as HeaderContextData);

const HeaderProvider: React.FC = ({ children }) => {
  const [header, dispatchHeader] = React.useReducer(
    (state: HeaderData, newValue: HeaderData) => {
      return { ...state, ...newValue };
    },
    { ...init },
  );
  return (
    <HeaderContext.Provider
      value={{
        header,
        dispatchHeader,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

function useHeader(): HeaderContextData {
  const context = useContext(HeaderContext);

  if (!context) {
    throw new Error('useHeader must be used within HeaderProvider');
  }

  return context;
}

export { useHeader, HeaderProvider };
